export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned',
        visible:false,
        switchable: false
    },
    {
        name: '__slot:rsy_ad_img',
        useInFilter: false,
        defaultSearch: false,
        visible:false,
        switchable: true
    },

    {
        name: '__slot:rsy_ad',
        sortField: 'title',
        type: 'string',
        useInFilter: true,
        defaultSearch: true,
        visible:false,
        switchable: true
    },
    {
        name: 'diff_days',
        sortField: 'diff_days',
        type: 'number',
        dataClass: 'ral',
        useInFilter: true,
        defaultSearch: false,
        visible:false,
        switchable: true
    },
    {
        name: 'legal',
        sortField: 'legal',
        type: 'string_without_in',
        useInFilter: true,
        defaultSearch: true,
        visible:false,
        switchable: true
    },
    {
        name: 'found_at',
        sortField: 'found_at',
        type: 'dateRange',
        useInFilter: true,
        defaultSearch: false,
        visible:false,
        switchable: true
    },
    {
        name: 'updated_at',
        sortField: 'updated_at',
        type: 'dateRange',
        useInFilter: true,
        defaultSearch: false,
        visible:false,
        switchable: true
    },
    {
        name: 'type',
        sortField: 'type',
        type: 'arr',
        useInFilter: true,
        defaultSearch: false,
        items: [
            {value: "Директ", label:"Директ"},
            {value: "Медиа", label:"Медиа"},
            {value: "App Store", label:"Моб. приложение (App Store)"},
            {value: "Google Play", label:"Моб. приложение (Google Play)"},
            {value: "Видео", label:"Видео"},
        ],
        visible:false,
        switchable: true
    },
    {
        name: 'size',
        sortField: 'size',
        type: 'string',
        useInFilter: false,
        defaultSearch: false,
        visible:false,
        switchable: true
    },
    {
        name: 'second_title',
        sortField: 'second_title',
        type: 'string',
        useInFilter: true,
        defaultSearch: true,
        visible:false,
        switchable: false
    },
    {
        name: 'body',
        sortField: 'body',
        type: 'string',
        useInFilter: true,
        defaultSearch: true,
        visible:false,
        switchable: false
    },
    {
        name: 'target_url',
        sortField: 'target_url',
        type: 'string',
        useInFilter: true,
        defaultSearch: true,
        visible:false,
        switchable: false
    },
    {
        name: 'view_cnt',
        sortField: 'view_cnt',
        type: 'number',
        useInFilter: true,
        defaultSearch: false,
        visible:false,
        switchable: false
    },
    {
        name: 'region',
        sortField: 'region_id',
        type: 'regions',
        useInFilter: true,
        defaultSearch: false,
        visible:false,
        switchable: false
    },
]
